"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_select_1 = require("react-select");
var __1 = require("..");
var styles = {
    checkboxWrapper: {
        display: 'flex',
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 8,
        img: {
            borderRadius: 6,
            marginRight: 4,
            maxWidth: 16,
            maxheight: 16,
        },
    },
};
var Option = function (props) {
    return ((0, jsx_runtime_1.jsx)(react_select_1.components.Option, __assign({}, props, { children: (0, jsx_runtime_1.jsx)("div", __assign({}, props.innerProps, { onClick: function (e) { return e.preventDefault(); }, css: styles.checkboxWrapper, style: {
                cursor: props.isDisabled ? 'default' : 'pointer',
            } }, { children: (0, jsx_runtime_1.jsx)(__1.Checkbox, { label: (0, jsx_runtime_1.jsxs)("div", __assign({ css: styles.label }, { children: [props.data.icon && ((0, jsx_runtime_1.jsx)("img", { src: props.data.icon, alt: props.label }, void 0)), props.label] }), void 0), onChange: function (e) { return e.preventDefault(); }, checked: props.isSelected }, void 0) }), void 0) }), void 0));
};
exports.Option = Option;
//# sourceMappingURL=Option.js.map